module.exports = __webpack_public_path__ + "img/icn_delete.37857782.svg";